import React from "react";
import get from "lodash/get";
import { Form, Checkbox } from "antd";

const AskIfReadyEditor = ({ form, event, getEventFieldName }) => (
  <Form.Item
    label="Ask if ready"
    labelCol={{ span: 3 }}
    wrapperCol={{ span: 21 }}
  >
    {form.getFieldDecorator(getEventFieldName(event, "ask_if_ready"), {
      initialValue: get(event, "ask_if_ready", undefined),
      valuePropName: "checked",
    })(<Checkbox>Ask the players if they are ready to proceed</Checkbox>)}
  </Form.Item>
);

export default AskIfReadyEditor;
